import React from 'react';
import TableC from '../../../basicElement/TableC';
import format from '../../../shared/format';

const IsBelongToMajorEvent = {
    0: '否',
    1: '是'
};

export default function MajorProgramViolation(props) {
    const { loading, data } = props;

    const getColumns = () => ([{
        title: '序号',
        dataIndex: 'index',
        key: 'index',
        width: 60,
    }, {
        title: '项目简称',
        dataIndex: 'investigationName',
        key: 'investigationName',
        width: 160,
    }, {
        title: '中心编号',
        dataIndex: 'investigationSiteCode',
        key: 'investigationSiteCode',
        width: 100,
    }, {
        title: '中心名称',
        dataIndex: 'investigationSiteName',
        key: 'investigationSiteName',
        width: 160,
    }, {
        title: '患者编号',
        dataIndex: 'patientUserCode',
        key: 'patientUserCode',
        width: 80,
    }, {
        title: '方案违背时间',
        dataIndex: 'violateDate',
        key: 'violateDate',
        width: 100,
        render: (text) => format('date', text),
    }, {
        title: '方案违背分类',
        dataIndex: 'violateType',
        key: 'violateType',
        width: 100,
    }, {
        title: '方案违背具体描述',
        dataIndex: 'violateDetailInfo',
        key: 'violateDetailInfo',
        width: 80,
    }, {
        title: '方案违背等级',
        dataIndex: 'violateLevel',
        key: 'violateLevel',
        width: 100,
    }, {
        title: '是否属于重大事件',
        dataIndex: 'isMajor',
        key: 'isMajor',
        width: 80,
        render: text => IsBelongToMajorEvent[text]
    }, {
        title: '涉及被带教人员',
        dataIndex: 'crcNameCodes',
        key: 'crcNameCodes',
        width: 100,
    }]);

    const getDataSource = () => {
        return data || [];
    };

    return (
        <div>
            <div style={{ lineHeight: '48px' }}>3.重大方案违背发生明细</div>
            <TableC
                scrollY={300}
                loading={loading}
                columns={getColumns()}
                data={getDataSource()}
                className="majorProgramViolation"
            />
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/home/TeachingDetail/tables/MajorProgramViolation.js